import {
    ADDIBANPROVIDER_SUCCESS,
    ADDIBANPROVIDER_FAILED,
    RESET_ADDIBANPROVIDER,
    LOADING_ADDIBANPROVIDER,
    NETWORK_ERROR_ADDIBANPROVIDER
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {},
    message: "",
    networkError: ""
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_ADDIBANPROVIDER:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {},
                message: "",
                networkError: ""
            };
        case ADDIBANPROVIDER_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload,
                message: "",
                networkError: ""
            };
        case ADDIBANPROVIDER_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload,
                message: "",
                networkError: ""
            };
        case NETWORK_ERROR_ADDIBANPROVIDER:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {},
                message: "",
                networkError: ""
            };
        case RESET_ADDIBANPROVIDER:
            return (state = initialState);
        default:
            return state;
    }
};